//Permisos relacionados con el emisor
export const ALL_PERMISOS_EMISOR = 1;
export const LISTAR_EMISOR = 2;
export const MODIFICAR_EMISOR = 3;
export const AGREGAR_CERTIFICADO_EMISOR = 4;
export const ELIMINAR_CERTIFICADO_EMISOR = 5;
export const ACTUALIZAR_IMAGEN_KUDE_EMISOR = 6;

//Permisos relacionados al usuario
export const ALL_PERMISOS_USUARIOS = 7;
export const CREAR_USUARIO = 8;
export const VINCULAR_USUARIO = 9;
export const LISTAR_USUARIOS = 10;
export const EDITAR_USUARIO = 11;
export const EDITAR_PERMISOS_USUARIOS = 12;
export const CAMBIAR_ESTADO_USUARIO = 13;
export const CAMBIAR_CLAVE_USUARIO = 14;

//Permisos relacionados con los documentos electrónicos
export const ALL_PERMISOS_DE = 15;
export const LISTAR_DE = 16;
export const VER_DETALLE_DE = 17;
export const CREAR_DE = 18;
export const EDITAR_DE = 19;
export const EVENTO_NOMINACION_DE = 20;
export const EVENTO_RECEPCION_DE = 21;
export const EVENTO_CONFORMIDAD_DE = 22;
export const EVENTO_DISCONFORMIDAD_DE = 23;
export const EVENTO_DESCONOCIMIENTO_DE = 24;
export const EVENTO_INUTILIZACION_DE = 25;
export const EVENTO_CANCELACION_DE = 26;
export const DESCARGAR_KUDE_DE = 27;
export const DESCARGAR_XML = 28;
export const VISOR_XML = 29;
export const ENVIAR_CORREO_DE = 30;
export const VER_EVENTOS_CORREOS_DE = 31;

//Permisos relacionados con los reportes
export const ALL_PERMISOS_REPORTES = 32;
export const REPORTE_VENTAS = 33;

//Permisos relacionados a los timbrados
export const LISTAR_TIMBRADO = 34;
export const MODIFICAR_TIMBRADO = 35;

//Binary search that check whether a given permission exists in the array
export const findPermission = (x, permissions) => {
    let start = 0;
    let end = permissions.length - 1;
    while (start <= end) {
        // Find the mid index
        let mid = Math.floor((start + end) / 2);

        // If element is present at
        // mid, return True
        if (permissions[mid] === x) return mid;
        // Else look in left or
        // right half accordingly
        else if (permissions[mid] < x) start = mid + 1;
        else end = mid - 1;
    }
    return -1;
};
